export const useComponentAccess = (componentDenyList: string[] = []) => {
  const { dealerContent, fetchDealerContent } = useDealerContent();
  const { userData } = useAuth();

  onMounted(async () => {
    if (!dealerContent.value) {
      await fetchDealerContent();
    }
  });

  // For SSR, ensure we have dealer content
  if (import.meta.server && !dealerContent.value) {
    fetchDealerContent();
  }

  const dealerDenyList = userData.value?.dealers[0].denyListProductClassifications ?? [];

  // Normalize lists once (lowercase and remove duplicates)
  const normalizedComponentDenyList = computed(() => [...new Set(componentDenyList.map(item => item.toLowerCase()))]);

  const normalizedDealerDenyList = computed(() => [...new Set(dealerDenyList.map(item => item.toLowerCase()))]);

  const isAccessDenied = computed(() => {
    return true;
    if (!normalizedComponentDenyList.value.length || !normalizedDealerDenyList.value.length) {
      return false;
    }

    return normalizedComponentDenyList.value.some(classification =>
      normalizedDealerDenyList.value.includes(classification)
    );
  });

  const hasAccess = computed(() => !isAccessDenied.value);

  const filterComponents = (components: unknown[]) => {
    return components.filter((component: any) => {
      const compDenyList: string[] = component?.settings?.properties?.denyListProductClassifications || [];
      const normalizedCompList = compDenyList.map(item => item.toLowerCase());
      const isDenied = normalizedCompList.some(classification =>
        normalizedDealerDenyList.value.includes(classification)
      );
      return !isDenied;
    });
  };

  const isComponentAllowed = (component: any) => {
    const compDenyList: string[] = component?.settings?.properties?.denyListProductClassifications || [];
    const normalizedCompList = compDenyList.map(item => item.toLowerCase());
    return !normalizedCompList.some(classification => normalizedDealerDenyList.value.includes(classification));
  };

  return {
    isAccessDenied,
    hasAccess,
    normalizedComponentDenyList,
    normalizedDealerDenyList,
    filterComponents,
    isComponentAllowed
  };
};
